export default {
  GYM_CLASS: 'Gym Class',
  HMOT: 'HMOT',
  BEAUTY: 'Beauty',
  PT: 'Personal Training',
};
